export default __webpack_public_path__ + "static/media/Vortex Gem.3d66bd91.jpg";